export enum StatsApi {
  STATISTIC = 'statistics',
  STATISTIC_EXCEL = 'statistics/excel',
}
